import React from "react";
import img1 from "../../../Assets/Homeimgs/OnlineCourses.svg";
import img2 from "../../../Assets/Homeimgs/ExpertTutors.svg";
import img3 from "../../../Assets/Homeimgs/certificate-icon.svg";
import img4 from "../../../Assets/Homeimgs/OnlineStudents.svg";
import img5 from "../../../Assets/Homeimgs/z.svg";
import { useIntersectionObserver } from "../../../Assets/CustomHook/CustomHook";
import CountUp from "react-countup";

const UnlockYour = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* soft glows - updated blue accents only */}
      <div className="pointer-events-none absolute -top-40 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-32 -right-40 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-4 md:px-8 lg:px-10 py-6 md:py-12 lg:py-14">
        <div className="text-center max-w-3xl mx-auto" data-aos="fade-up">
          <p className="text-[10px] sm:text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#064585]">
            Now Is Always The Right Time To Start
          </p>

          <h1 className="mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight md:leading-tight">
            Unlock Your{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Creative Potential
            </span>{" "}
            In Development
          </h1>

          <p className="mt-4 text-sm sm:text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
            Learn modern web development from industry experts with our flexible
            online and offline courses. Build real-world projects and get
            job-ready skills.
          </p>
        </div>

        {/* Counters */}
        <div
          className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5 md:gap-6"
          ref={ref}
        >
          <div
            className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-4 sm:px-5 sm:py-5"
            data-aos="zoom-in"
          >
            <img
              src={img1}
              alt="admission"
              className="w-12 h-12 sm:w-14 sm:h-14"
            />
            <div>
              <h3 className="text-xl font-semibold text-[#064585]">
                {isVisible && <CountUp start={0} end={10000} duration={5} />}+
              </h3>
              <p className="text-xs sm:text-sm text-slate-600">
                Student Admission
              </p>
            </div>
          </div>

          <div
            className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-4 sm:px-5 sm:py-5"
            data-aos="zoom-in-up"
          >
            <img
              src={img2}
              alt="courses"
              className="w-12 h-12 sm:w-14 sm:h-14"
            />
            <div>
              <h3 className="text-xl font-semibold text-[#064585]">
                {isVisible && <CountUp start={0} end={10} duration={5} />}+
              </h3>
              <p className="text-xs sm:text-sm text-slate-600">
                Online/Offline Courses
              </p>
            </div>
          </div>

          <div
            className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-4 sm:px-5 sm:py-5"
            data-aos="zoom-in-down"
          >
            <img
              src={img3}
              alt="placed"
              className="w-12 h-12 sm:w-14 sm:h-14"
            />
            <div>
              <h3 className="text-xl font-semibold text-[#064585]">
                {isVisible && <CountUp start={0} end={500} duration={5} />}+
              </h3>
              <p className="text-xs sm:text-sm text-slate-600">
                Students Placed
              </p>
            </div>
          </div>

          <div
            className="bg-white/80 backdrop-blur rounded-2xl shadow-md border border-[#5989C8]/20 flex items-center gap-4 px-4 py-4 sm:px-5 sm:py-5"
            data-aos="zoom-in-left"
          >
            <img
              src={img4}
              alt="projects"
              className="w-12 h-12 sm:w-14 sm:h-14"
            />
            <div>
              <h3 className="text-xl font-semibold text-[#064585]">
                {isVisible && <CountUp start={0} end={800} duration={5} />}+
              </h3>
              <p className="text-xs sm:text-sm text-slate-600">
                Projects Completed
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 text-center" data-aos="flip-up">
          <div className="inline-flex items-center gap-3 bg-white/80 backdrop-blur rounded-2xl border border-[#5989C8]/20 px-4 sm:px-6 py-3 shadow-md">
            <img
              src={img5}
              alt="logo"
              className="w-9 h-9 sm:w-11 sm:h-11"
              data-aos="zoom-out-up"
            />
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-wide"
              data-aos="zoom-out-right"
            >
              <span className="text-[#064585]">Unlock</span> Your Creative
              Potential
            </h2>
          </div>
          <p
            className="mt-3 text-lg md:text-2xl font-normal text-slate-700"
            data-aos="zoom-out-left"
          >
            With Online and Offline Development Courses.
          </p>
        </div>
      </div>
    </section>
  );
};

export default UnlockYour;
